import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-login-verification-code-dialog',
    templateUrl: './login-verification-code-dialog.component.html',
    styleUrls: ['./login-verification-code-dialog.component.scss'],
})
export class LoginVerificationCodeDialogComponent {
    verificationCode: string;

    constructor(private dialogRef: MatDialogRef<LoginVerificationCodeDialogComponent>) {}

    close(): void {
        this.dialogRef.close();
    }

    login(): void {
        this.dialogRef.close(this.verificationCode);
    }
}

